import type { ReactNode } from "react";

interface FieldGridProps {
  /** Grid column count. Defaults to 2 (matches inspector density target). */
  cols?: 2 | 3;
  children: ReactNode;
}

/**
 * Iter 27 — denser layout container for short inspector fields
 * (format, variant, unit, sort, limit, etc.). Replaces the previous
 * vertical stack so 4 short fields fit in 2 rows instead of 4.
 *
 * Long fields (textarea, SQL, bilingual inputs that need full width)
 * should still wrap with ``className="col-span-full"`` if rendered
 * inside this grid, or live outside it.
 */
export function FieldGrid({
  cols = 2,
  children,
}: FieldGridProps): JSX.Element {
  const colsClass = cols === 3 ? "grid-cols-3" : "grid-cols-2";
  return <div className={`grid ${colsClass} gap-x-3 gap-y-2`}>{children}</div>;
}
